/* Naya Attire theme scripts */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = (format || 'Rs {{amount}}').replace(/<[^>]*>/g, '');
    function withDelimiters(num, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'"); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  // Horizontal swipe detection (touch). Calls onLeft/onRight; marks the element so the
  // tap that ends a swipe doesn't also count as a click.
  function onSwipe(el, onLeft, onRight) {
    if (!el) return;
    var x0 = null, y0 = null;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        el.setAttribute('data-swiped', '1');
        setTimeout(function () { el.removeAttribute('data-swiped'); }, 400);
        if (dx < 0) onLeft(); else onRight();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var theme = window.theme || {};
    var strings = theme.strings || { addToCart: 'Add to cart', soldOut: 'Sold out', unavailable: 'Unavailable' };

    // Mobile menu
    var menuBtn = document.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('MobileMenu');
    if (menuBtn && menu) {
      menuBtn.addEventListener('click', function () {
        var open = menu.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', open);
      });
    }

    // Search toggle
    var searchBtn = document.querySelector('[data-search-toggle]');
    var search = document.getElementById('HeaderSearch');
    if (searchBtn && search) {
      searchBtn.addEventListener('click', function () {
        var open = search.classList.toggle('is-open');
        searchBtn.setAttribute('aria-expanded', open);
        if (open) { var i = search.querySelector('input[type=search]'); if (i) i.focus(); }
      });
    }

    // Quantity buttons (product + cart)
    document.querySelectorAll('.qty').forEach(function (box) {
      var input = box.querySelector('input');
      if (!input) return;
      box.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var min = parseInt(input.min || '0', 10);
          var v = (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qty, 10);
          input.value = Math.max(min, v);
        });
      });
    });

    // Collection sorting
    var sort = document.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Product page: variants + gallery
    document.querySelectorAll('[data-product-root]').forEach(function (root) {
      // The product JSON sits next to the .wrap div (not inside root's parent), so search the whole section.
      var scope = root.closest('.shopify-section') || document;
      var jsonEl = scope.querySelector('[data-product-json]');
      var product = null;
      try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (err) { product = null; }
      var idInput = root.querySelector('[data-variant-id]');
      var addBtn = root.querySelector('[data-add-btn]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');

      /* ---------- Gallery ---------- */
      var mainWrap = root.querySelector('[data-main-media]');
      var mainImg = root.querySelector('[data-main-media] img');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var counter = root.querySelector('[data-gallery-counter]');
      var lb = root.querySelector('[data-lightbox]');
      var lbImg = lb ? lb.querySelector('[data-lb-img]') : null;
      var lbCounter = lb ? lb.querySelector('[data-lb-counter]') : null;
      var lastFocus = null;

      var slides = thumbs.map(function (t) {
        return { id: String(t.dataset.mediaId), src: t.dataset.src, full: t.dataset.full || t.dataset.src, alt: t.dataset.alt || '' };
      });
      if (!slides.length && mainImg) {
        var only = mainImg.currentSrc || mainImg.src;
        slides = [{ id: '', src: only, full: (lbImg && lbImg.src) || only, alt: mainImg.alt || '' }];
      }
      var index = 0;
      thumbs.forEach(function (t, i) { if (t.classList.contains('is-active')) index = i; });

      function isOpen() { return lb && !lb.hidden; }

      function render() {
        var s = slides[index];
        if (!s) return;
        if (mainImg && s.src && thumbs.length) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = s.src;
          mainImg.alt = s.alt;
        }
        thumbs.forEach(function (t, i) {
          var on = i === index;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        var label = (index + 1) + ' / ' + slides.length;
        if (counter) counter.textContent = label;
        if (lbImg) { lbImg.src = s.full; lbImg.alt = s.alt; }
        if (lbCounter) lbCounter.textContent = slides.length > 1 ? label : '';
      }

      function go(i) {
        if (!slides.length) return;
        index = (i + slides.length) % slides.length;
        render();
      }
      function next() { go(index + 1); }
      function prev() { go(index - 1); }

      function showMedia(src, mediaId) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].id === String(mediaId)) { go(i); return; }
        }
      }

      function openLightbox() {
        if (!lb) return;
        lastFocus = document.activeElement;
        render();
        lb.hidden = false;
        document.documentElement.classList.add('lb-open');
        var closeBtn = lb.querySelector('[data-lb-close]');
        if (closeBtn) closeBtn.focus();
      }
      function closeLightbox() {
        if (!isOpen()) return;
        lb.hidden = true;
        document.documentElement.classList.remove('lb-open');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { go(i); });
      });

      var prevBtn = root.querySelector('[data-gallery-prev]');
      var nextBtn = root.querySelector('[data-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); next(); });

      var zoomBtn = root.querySelector('[data-open-lightbox]');
      if (zoomBtn) {
        zoomBtn.addEventListener('click', function () {
          if (mainWrap && mainWrap.hasAttribute('data-swiped')) return;
          openLightbox();
        });
      }
      if (slides.length > 1) onSwipe(mainWrap, next, prev);

      if (lb) {
        if (slides.length < 2) {
          lb.querySelectorAll('[data-lb-prev],[data-lb-next]').forEach(function (b) { b.hidden = true; });
        }
        lb.querySelector('[data-lb-close]').addEventListener('click', closeLightbox);
        lb.querySelector('[data-lb-prev]').addEventListener('click', function (e) { e.stopPropagation(); prev(); });
        lb.querySelector('[data-lb-next]').addEventListener('click', function (e) { e.stopPropagation(); next(); });
        lb.addEventListener('click', function (e) {
          if (lb.hasAttribute('data-swiped')) return;
          if (e.target === lb) closeLightbox();
        });
        if (slides.length > 1) onSwipe(lb, next, prev);
        document.addEventListener('keydown', function (e) {
          if (!isOpen()) return;
          if (e.key === 'Escape') { closeLightbox(); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
        });
      }

      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;

      /* ---------- Variants ---------- */
      if (!product || !product.variants) return;
      var radios = root.querySelectorAll('input[data-option-index]');
      function currentOptions() {
        var opts = [];
        radios.forEach(function (r) { if (r.checked) opts[parseInt(r.dataset.optionIndex, 10)] = r.value; });
        return opts;
      }
      function update() {
        var opts = currentOptions();
        opts.forEach(function (v, i) {
          var l = root.querySelector('[data-option-label="' + i + '"]');
          if (l) l.textContent = v;
        });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!variant) {
          addBtn.disabled = true;
          addBtn.textContent = strings.unavailable;
          return;
        }
        idInput.value = variant.id;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? strings.addToCart : strings.soldOut;
        if (priceEl) priceEl.textContent = formatMoney(variant.price, theme.moneyFormat);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.hidden = false;
            compareEl.textContent = formatMoney(variant.compare_at_price, theme.moneyFormat);
          } else { compareEl.hidden = true; }
        }
        if (variant.featured_media) {
          showMedia(null, variant.featured_media.id);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      radios.forEach(function (r) { r.addEventListener('change', update); });
    });
  });
})();
